import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Button } from 'V2/Shared/Button';
import { Input } from 'V2/Shared/Form';
import { useVerifyZip } from 'V2/Checkout/hooks/useVerifyZip';
import styles from '../styles.module.css';

const validationSchema = Yup.object({
  zip_code: Yup.string()
    .matches(/^\d{5}$/, 'Please enter a valid 5-digit ZIP code')
    .required('ZIP code is required'),
});

interface ZipCodeFormProps {
  onLockout: () => void;
}

export const ZipCodeForm: React.FC<ZipCodeFormProps> = ({ onLockout }) => {
  const { fieldError, isSubmitting, submit } = useVerifyZip(onLockout);

  return (
    <Formik
      initialValues={{ zip_code: '' }}
      validationSchema={validationSchema}
      onSubmit={({ zip_code }) => submit(zip_code)}
    >
      {({ errors, touched }) => (
        <Form noValidate>
          <div className={styles.fieldGroup}>
            <Input
              name="zip_code"
              label="ZIP code"
              type="text"
              autoComplete="postal-code"
              autoFocus
              dataTestId="zip-code-input"
              pattern="[0-9]*"
              normalize={(value) => value.replace(/\D/g, '').slice(0, 5)}
            />
            {touched.zip_code && errors.zip_code && (
              <p
                className={styles.errorText}
                role="alert"
                data-testid="zip-error"
              >
                {errors.zip_code}
              </p>
            )}
            {!(touched.zip_code && errors.zip_code) && fieldError && (
              <p
                className={styles.errorText}
                role="alert"
                data-testid="zip-error"
              >
                {fieldError}
              </p>
            )}
          </div>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            width="fullWidth"
            isSubmitting={isSubmitting}
            disabled={isSubmitting}
            data-testid="verify-submit"
          >
            Continue
          </Button>
        </Form>
      )}
    </Formik>
  );
};
